<template>
  <q-btn-dropdown
    v-bind="$attrs"
    align="between"
    content-class="bg-responsive"
    content-style="max-height: 300px"
    :persistent="!!geoapifyEnabled"
    data-test-id="site-selector-zones-selectbox"
  >
    <template
      #label
    >
      <div class="row items-center no-wrap ">
        <q-icon
          v-if="!hideIcon"
          class="q-px-none"
          left
          name="fal fa-location-dot"
        />
        <div
          class="text-left ellipsis"
        >
          {{ currentSite.displayName }}
        </div>
      </div>
    </template>
    <div>
      <q-list bordered>
        <site-location-look-up
          class="q-px-sm"
          :redirect-home-page="redirectHomePage"
          :is-widget="isWidget"
          dropdown-list-view
          hide-address
          @all-locations-shown="shown => showAllLocation = shown"
          @loading="value => loading = value"
        />
      </q-list>
      <template v-if="showAllLocation">
        <site-selector-locations-list
          :sites-without-location-zone-id="sitesWithoutLocationZoneId"
          :location-zones="locationZones"
          :site-locations="siteLocations"
          :redirect-home-page="redirectHomePage"
          default-opened
          dropdown-list-view
          hide-address
          bordered
        />
      </template>
    </div>
  </q-btn-dropdown>
</template>

<script>
import { geoapifyEnabled } from 'src/config'
import SiteLocationsListMixin from 'src/modules/consumer/components/mixins/SiteLocationsListMixin'
import SiteLocationLookUp from 'src/modules/consumer/components/site-selector/SiteLocationLookUp'
import SiteSelectorLocationsList from 'src/modules/consumer/components/site-selector/SiteSelectorLocationsList'
export default {
  name: 'SiteSelectorZonesSelectbox',
  components: {
    SiteSelectorLocationsList,
    SiteLocationLookUp
  },
  mixins: [SiteLocationsListMixin],
  props: {
    compactView: {
      type: Boolean,
      required: false,
      default: false
    },
    redirectHomePage: {
      type: Boolean,
      required: false,
      default: false
    },
    hideIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    isWidget: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      showAllLocation: true
    }
  },
  created () {
    _.extend(this, {
      geoapifyEnabled
    })
  }

}
</script>
